import React from "react";
import LoadingImg from "../images/loading.gif";
import "../css/loading.css";

export default () => {
  return (
    <div className="loadingContent" id="loadingContent">
      <div className="loading-center">
        <img src={LoadingImg} alt="" />
      </div>
    </div>
  );
};
